import { useCallback, useEffect, useState } from "react";

import {
	BookkeepingCheckActivityContext,
	bookkeepingCheckActivityHub,
	defaultContextValue,
} from "./BookkeepingCheckActivityContext";

import type { BookkeepingCheckActivityMessage, BookkeepingCheckActivityState } from "./BookkeepingCheckActivityContext";
import type { FC, PropsWithChildren } from "react";

export const BookkeepingCheckActivityProvider: FC<PropsWithChildren> = props => {
	const [state, setState] = useState<BookkeepingCheckActivityState>(defaultContextValue);

	const onMessage = useCallback((message: BookkeepingCheckActivityMessage) => {
		setState(prevState => ({
			counter: (prevState.counter + 1) % (Number.MAX_SAFE_INTEGER - 1),
			lastCheckId: message.CheckId,
			lastStatus: message.Status,
			lastVerificationId: message.VerificationId ?? undefined,
		}));
	}, []);

	useEffect(() => {
		bookkeepingCheckActivityHub.add(onMessage);

		return () => {
			bookkeepingCheckActivityHub.remove(onMessage);
		};
	}, [onMessage]);

	return <BookkeepingCheckActivityContext value={state}>{props.children}</BookkeepingCheckActivityContext>;
};
